import React, { useMemo } from 'react';
import { Users, Building2, MapPin, UserCheck } from 'lucide-react';

const DirectoryStats = ({ employees, departments }) => {
  const stats = React.useMemo(() => {
    if (!employees || employees?.length === 0) {
      return {
        totalEmployees: 0,
        activeEmployees: 0,
        totalDepartments: departments?.length || 0,
        uniqueLocations: 0
      };
    }

    const activeEmployees = employees?.filter(emp => emp?.status === 'active')?.length;
    const uniqueLocations = new Set(
      employees
        .map(emp => emp?.location)
        .filter(Boolean)
    )?.size;

    return {
      totalEmployees: employees?.length,
      activeEmployees,
      totalDepartments: departments?.length || 0,
      uniqueLocations
    };
  }, [employees, departments]);

  const statCards = [
    {
      title: 'Total Employees',
      value: stats?.totalEmployees,
      icon: Users,
      color: 'bg-blue-500',
      bgColor: 'bg-blue-50',
      textColor: 'text-blue-600'
    },
    {
      title: 'Active Employees',
      value: stats?.activeEmployees,
      icon: UserCheck,
      color: 'bg-green-500',
      bgColor: 'bg-green-50',
      textColor: 'text-green-600'
    },
    {
      title: 'Departments',
      value: stats?.totalDepartments,
      icon: Building2,
      color: 'bg-purple-500',
      bgColor: 'bg-purple-50',
      textColor: 'text-purple-600'
    },
    {
      title: 'Locations',
      value: stats?.uniqueLocations,
      icon: MapPin,
      color: 'bg-orange-500',
      bgColor: 'bg-orange-50',
      textColor: 'text-orange-600'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {statCards?.map((stat) => (
        <div key={stat?.title} className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center">
            <div className={`${stat?.bgColor} rounded-lg p-3 mr-4`}>
              <stat.icon className={`h-6 w-6 ${stat?.textColor}`} />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-600">{stat?.title}</p>
              <p className="text-2xl font-semibold text-gray-900">{stat?.value}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DirectoryStats;